import React from "react";
import { Box } from "@mui/material";

import {
  deleteShipmentFile,
  downloadShipmentFile,
  getShipmentFileList,
  uploadShipmentFiles,
} from "../../api/imports";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useSnack } from "../../services/SnakbarProvider";
import FileUpload from "../../screens/Lab/mockAddFile";
import { handleError } from "../../services/errorHandler";
import GenericFileUpload from "../Common/GenericFileUpload";

const fileOptions = [
  "Guia de embarque",
  "Lista de empaque",
  "Factura de proveedor",
  "Pedimento",
  "Cuenta de Gastos (ZIP)",
  "Factura de demora",
  "Comprobante de pago",
  "Factura de agente aduanal"
];

export default function UpdateFileForm({ props }) {
  const { id } = props;
  const { openSnack } = useSnack();

  const handleFileDownload = async (id, row) => {
    try {
      const response = await downloadShipmentFile(id);
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "downloadedFile";

      if (
        contentDisposition &&
        contentDisposition.indexOf("attachment") !== -1
      ) {
        // Extract filename from Content-Disposition header
        const matches = contentDisposition.match(/filename="([^"]*)"/);
        if (matches && matches[1]) {
          fileName = matches[1];
        }
      }

      // Rename the file to "{fileConcept} - {fileCode}", keeping the original extension
      if (row?.fileConcept) {
        const dotIndex = fileName.lastIndexOf(".");
        const fileExtension = dotIndex !== -1 ? fileName.slice(dotIndex) : "";
        const codeSuffix = row.fileCode ? ` - ${row.fileCode}` : "";
        fileName = `${row.fileConcept}${codeSuffix}${fileExtension}`;
      }

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Set the download attribute with the filename including extension
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  return (
    <>
      <Box width={"100%"}>
        {id && (
          <LGModalCrud
            props={{
              actions: ["create", "download", "delete"],
              data: { shipmentId: id },
              fetchFunction: getShipmentFileList,
              deleteFunction: deleteShipmentFile,
              downloadFunction: handleFileDownload,
              detailMenu: [
                {
                  label: "Descargar",
                  handler: handleFileDownload,
                  header: "Descargar",
                  body: <FileUpload />,
                },
              ],
              columns: [
                {
                  field: "fileConcept",
                  headerName: "Tipo de documento",
                  flex: 0.5,
                },
                {
                  field: "fileCode",
                  headerName: "Clave del documento",
                  flex: 0.5,
                }

              ],
              addModalData: {
                header: "Agregar Documentos",
                body: (
                  <GenericFileUpload
                    fileNameOptions={fileOptions}
                    uploadFunction={uploadShipmentFiles}
                    id={id}
                  />
                ),
              },
              editModalData: {
                header: "Editar Proveedor",
                body: <p>Formulario editar archivo</p>,
              },
            }}
          />
        )}
      </Box>
    </>
  );
}
